function RenderCategoryItemSelectors(props) {
  const { categoryDataItemSelectors } = props

  return (
    Object.values(categoryDataItemSelectors).map((selector, index) => {
      return (
        selector ?
          <blockquote key={index} className="code-blockquote mb-4 p-4 py-4 px-xl-6 fs-6 bg-primary pdf-avoid-break">
            <code className="text-white"><small>{selector}</small></code>
          </blockquote>
          : ''
      )
    })
  );
}

export default RenderCategoryItemSelectors